import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PlaceholderContext } from "../../contexts/Contexts";
import { $serializeForm } from "../../main";
import { UnitSchemaActions } from '../../redux/slices/UnitSchemaSlice';
import { CREATE_UNIT_SCHEMA, DELETE_UNIT_SCHEMA, UPDATE_UNIT_SCHEMA } from "../../api/Api";
import { Loading } from "../Loaders";
import { LoadingSvg } from "../../icons/Icon";

export const UnitSchema = (p) => {

    const placeholder = useContext(PlaceholderContext);
    const form = useRef(null);
    const [button, setButtonState] = useState('Submit');

    function unitSchemaState(state) {
        switch (state) {
            case 'loading':
            case 'working':
                setButtonState(<Loading><LoadingSvg /></Loading>);
                break;
            case 'done':
                placeholder.openAlert({
                    onApprove: (a) => {
                        a.actions.close();
                    }
                }, {
                    heading: 'Success',
                    message: 'Task successful'
                })
                p.done();
                p.success();
                setButtonState('Submit');
                break;
            case 'error':
                placeholder.openAlert({
                    onApprove: (a) => {
                        a.actions.close();
                    }
                }, {
                    heading: 'Warning',
                    message: 'Task failed, try again.'
                })
                p.error();
                setButtonState('Try Again');
                break;
        }
    }
    useEffect(() => {
        unitSchemaState(p.state);
    }, [p.state]);

    const onClick = (e) => {
        e.preventDefault();
        if (p.state !== 'loading' || p.state !== 'working') {
            var [encoded, json] = $serializeForm(form.current);
            //console.log('UnitSchema', json);
            p.submit(json);
        }
    };

    return (
        <form ref={form} className="simple-form">
            <div className="flex-24">
                <div className="col-24 flex-column">
                    <div className="flex-column">
                        {p.id && <input type="text" name="id" defaultValue={p.id} style={{ display: 'none' }} />}
                        <label title=""><span>Product type</span><input type="text" name="name" placeholder="" defaultValue={p.value || ''} { ...(p.disabled ? { disabled : true} : '') } /></label>
                    </div>
                    <div className="flex-column"><button onClick={onClick} className='simple-form-button' >{button}</button></div>
                </div>
            </div>
        </form>
    );
};

export const NewUnitSchema = (p) => {

    const dispatch = useDispatch();
    const create = useSelector((state) => state.unitSchema.create);

    return (
        <UnitSchema
            state={create}
            disabled={false}
            success={p.success}
            done={() => dispatch(UnitSchemaActions.resetCreate())}
            error={() => dispatch(UnitSchemaActions.resetCreate())}
            submit={(json) => dispatch(UnitSchemaActions.setUnitSchema(CREATE_UNIT_SCHEMA(json)))}
        />
    );
};

export const DeleteUnitSchema = (p) => {

    const dispatch = useDispatch();
    const $delete = useSelector((state) => state.unitSchema.delete);

    return (
        <UnitSchema
            state={$delete}
            value={p.value}
            id={p.id}
            disabled={true}
            success={p.success}
            done={() => dispatch(UnitSchemaActions.resetDelete())}
            error={() => dispatch(UnitSchemaActions.resetDelete())}
            submit={(json) => dispatch(UnitSchemaActions.deleteUnitSchema(DELETE_UNIT_SCHEMA(json['id'])))}
        />
    );
};

export const EditUnitSchema = (p) => {

    const dispatch = useDispatch();
    const update = useSelector((state) => state.unitSchema.update);

    return (
        <UnitSchema
            state={update}
            value={p.value}
            id={p.id}
            disabled={false}
            success={p.success}
            done={() => dispatch(UnitSchemaActions.resetUpdate())}
            error={() => dispatch(UnitSchemaActions.resetUpdate())}
            submit={(json) => dispatch(UnitSchemaActions.putUnitSchema(UPDATE_UNIT_SCHEMA(json)))}
        />
    );
};